<template>
  <div class="baseBg">
    <div
      class="baseBg-banner"
      :style="{ background: `url(${img[bgUrl]}) no-repeat` }"
    ></div>
  </div>
</template>

<script>
import aboutbg from "@/assets/img/bgBanner/about.png"; // 关于我们
import branchbg from "@/assets/img/bgBanner/branch.png"; // 分布介绍
import consultingbg from "@/assets/img/bgBanner/consulting.png"; // 留言反馈
import leavingbg from "@/assets/img/bgBanner/leaving.png"; // 留言
import newbg from "@/assets/img/bgBanner/new.png"; // 新闻
import periodicalbg from "@/assets/img/bgBanner/periodical.png"; // 期刊出版
import learningbg from "@/assets/img/bgBanner/learning.png"; // 学术交流

export default {
  name: "PclearningHome",
  props: {
    bgUrl: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      img: {
        learningbg,
        periodicalbg,
        aboutbg,
        branchbg,
        consultingbg,
        leavingbg,
        newbg
      }
    };
  }
};
</script>

<style lang="less">
.baseBg {
  &-banner {
    margin-bottom: 90px;
    width: 100%;
    height: 410px;
    box-sizing: border-box;
  }
}
</style>
